"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatEventsEmitter = void 0;
var ChatEventsEmitter = exports.ChatEventsEmitter = {
  events: {},
  lastUid: -1,
  dispatch: function dispatch(event) {
    var hasSubscribers = this.eventHasSubscribers(event);
    var subscribers = this.events[event];
    if (!hasSubscribers) {
      return;
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    for (var s in subscribers) {
      if ({}.hasOwnProperty.call(subscribers, s)) {
        var cb = subscribers[s];
        this.callSubscriber.apply(this, [cb].concat(args));
      }
    }
  },
  callSubscriber: function callSubscriber(fn) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    fn.apply(void 0, args);
  },
  subscribe: function subscribe(event, callback) {
    var _this = this;
    this.events[event] = this.events[event] || {};
    var index = "uuid_".concat(String(++this.lastUid));
    this.events[event][index] = callback;
    return function () {
      delete _this.events[event][index];
    };
  },
  eventHasSubscribers: function eventHasSubscribers(event) {
    return {}.hasOwnProperty.call(this.events, event);
  },
  unsubscribeAll: function unsubscribeAll() {
    this.events = {};
  }
};

// export default ChatEventsEmitter;